export const SIDEBAR_WIDTH = 280;
export const ACCOUNT_DRAWER_WIDTH = 300;
export const ACCOUNT_DRAWER_ICON_WIDTH = 32;
